import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '.'
import { SimulationRequestType } from './types'

interface ISliceState {
  isAccountVerified: boolean
  isCustomMfaCompleted: boolean
  contextKey?: string
  profileKey?: string
  totpSessionKey?: string
  simulationReq?: SimulationRequestType | null
}

const initialState: ISliceState = {
  isAccountVerified: false,
  isCustomMfaCompleted: false
}

const Slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    SetAccountVerifiedStatus: (state, action: PayloadAction<boolean>) => {
      return { ...state, isAccountVerified: action.payload }
    },
    SetProfileContextKey: (state, action: PayloadAction<{ contextKey: string; profileKey: string }>) => {
      return { ...state, contextKey: action.payload.contextKey, profileKey: action.payload.profileKey }
    },
    SetSimulationRequest: (state, action: PayloadAction<SimulationRequestType | null | undefined>) => {
      return { ...state, simulationReq: action.payload }
    },
    SetCustomMfaCompletedStatus: (state, action: PayloadAction<boolean>) => {
      return { ...state, isCustomMfaCompleted: action.payload }
    },
    SetTotpSessionKey: (state, action: PayloadAction<string | undefined>) => {
      return { ...state, totpSessionKey: action.payload }
    }
  }
})

export const getIsAccountVerified = (state: RootState) => state.app.isAccountVerified
export const getProfileKey = (state: RootState) => state.app.profileKey
export const getContextKey = (state: RootState) => state.app.contextKey
export const getSimulationReq = (state: RootState) => state.app.simulationReq
export const isSimulation = (state: RootState) => !!state.app.simulationReq
export const getIsCustomMfaCompleted = (state: RootState) => state.app.isCustomMfaCompleted
export const getTotpSessionKey = (state: RootState) => state.app.totpSessionKey
export const {
  SetAccountVerifiedStatus,
  SetProfileContextKey,
  SetSimulationRequest,
  SetCustomMfaCompletedStatus,
  SetTotpSessionKey
} = Slice.actions
export default Slice.reducer
